export const siteSettings = {
  name: "Vantage Trade Assets",
  link: "https://vantageassets.live",
  email: "support@vantageassets.live",
  appLink: "https://app.vantageassets.live",
};
